import Vue from "vue";
import { USER_NAME, USER_INFO } from "@/store/mutation-types";
import QrcodeVue from "qrcode.vue";
import { getActivityDetail } from "@/api/goods";
import { getAction } from "@/api/manage";
export default {
  name: "CourseGoodsDetail",
  components: {
    QrcodeVue: QrcodeVue
  },
  data: function data() {
    return {
      actId: "",
      //   userInfo: {},
      //   userId: "",
      activityInfo: {},
      buyQrcodeShow: false
    };
  },
  created: function created() {
    this.actId = this.$route.query.actId;
    this.userInfo = this.$store.state.user.info;
    // if (this.userInfo === null) {
    // } else {
    //   this.userId = this.userInfo.id;
    // }
    this.getActivityInfo();
  },
  methods: {
    getActivityInfo: function getActivityInfo() {
      var _this = this;
      getActivityDetail(this.actId).then(function (res) {
        _this.activityInfo = res.result;
        window.document.title = _this.activityInfo.landingTitle || _this.activityInfo.activityName;
      });
    },
    toBuy: function toBuy() {
      var _this2 = this;
      console.log(Vue.ls.get(USER_INFO));
      if (Vue.ls.get(USER_INFO) != null) {
        // if(this.activityInfo.price == 0){
        getAction("/teaching/teachingActivity/freeByActivity?activityId=" + this.activityInfo.activityId).then(function (res) {
          if (res.success) {
            _this2.$message.success(res.message);
          } else {
            _this2.$message.info(res.message);
          }
        });
        // }else{
        // this.buyQrcodeShow = true;
        // }
      } else {
        this.$message.error("请先登录");
      }
    },
    getBuyLink: function getBuyLink() {
      if (Vue.ls.get(USER_INFO) == null) {
        return "";
      }
      var url = window.location.protocol + "//" + window.location.host + "/mobile/landing.html?actId=" + this.actId + "&userId=" + Vue.ls.get(USER_INFO).id;
      return url;
    }
  }
};